<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">Crear Proforma</h1>
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <b-card header-tag="header" footer-tag="footer" no-body>
              <form-wizard
                color="#0074d9"
                errorColor="#ff4136"
                ref="wizard"
                shape="circle"
                stepSize="sm"
                nextButtonText="Siguiente"
                backButtonText="Atrás"
                finishButtonText="Finalizar"
                @on-complete="$router.push({ name: 'Listar Proformas' })"
                title=""
                subtitle=""
              >
                <tab-content title="Información del documento" :before-change="validateStep1">
                  <b-row>
                    <b-col lg="10">
                      <b-form-group label="Rango de fecha">
                        <date-range-picker
                          v-model="$v.dateRange.$model"
                          :state="$v.dateRange.$dirty ? !$v.dateRange.$error : null"
                          :startDate="startDate"
                          :endDate="endDate"
                          :locale-data="locale"
                          :ranges="ranges"
                          opens="right"
                          :show-week-numbers="showWeekNumbers"
                          @update="updateValues"
                          :autoApply="autoApply"
                        >
                          <div slot="input" slot-scope="picker" style="min-width: 350px">
                            <i class="fa fa-calendar text-primary"></i>
                            {{ picker.startDate | fecha }} - {{ picker.endDate | fecha }}
                          </div>
                        </date-range-picker>
                      </b-form-group>

                      <b-form-group label="Exportadora">
                        <b-form-select
                          id="client"
                          v-model="$v.client_customer.$model"
                          :state="$v.client_customer.$dirty ? !$v.client_customer.$error : null"
                          @change="getCompanies"
                          :options="customers"
                        ></b-form-select>
                      </b-form-group>

                      <b-form-group label="Empresa">
                        <b-form-select
                          id="company"
                          v-model="$v.company.$model"
                          :state="$v.company.$dirty ? !$v.company.$error : null"
                          :options="companies"
                        ></b-form-select>
                      </b-form-group>
                      <b-form-group label="Dólar observado">
                        <b-input
                          v-model="$v.currency_selected.$model"
                          :state="$v.currency_selected.$dirty ? !$v.currency_selected.$error : null"
                        ></b-input>
                      </b-form-group>
                      <b-form-group label="Descripción en factura">
                        <b-input
                          placeholder="Ej. Adelanto por fruta de exportación."
                          v-model="$v.description.$model"
                          :state="$v.description.$dirty ? !$v.description.$error : null"
                        ></b-input>
                      </b-form-group>
                    </b-col>

                    <b-col lg="2">
                      <p class="font-weight-bold">Dólar observado</p>
                      <b-table small bordered sticky-header="200px" head-variant="light" :items="currency.serie">
                        <template v-slot:cell(fecha)="row">
                          {{ row.item.fecha | fecha }}
                        </template>
                        <template v-slot:cell(valor)="row">
                          <a
                            href="#"
                            @click.prevent="
                              () => {
                                currency_selected = row.item.valor;
                              }
                            "
                            >{{ row.item.valor }}</a
                          >
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                </tab-content>

                <tab-content title="Detalle de la proforma (fruta)">
                  <b-spinner v-if="loading"></b-spinner>
                  <b-modal title="Copiar valor para todas las cajas" @ok="copyValues" size="sm" id="copy-value-modal">
                    <b-form-group label="USD/Kg">
                      <b-input type="number" v-model="copy"></b-input>
                    </b-form-group>
                    * Revise igualmente las cajas que se pagarán.
                  </b-modal>
                  <div>
                    <b-table small striped hover :items="items" :fields="getFields">
                      <template v-slot:cell(week)="row">
                        {{ row.item.waybill_date | week }}
                      </template>
                      <template v-slot:head(actions)="row">
                        USD/Kg <a href="#" v-b-modal.copy-value-modal><i class="fa fa-copy"></i></a>
                      </template>
                      <template v-slot:cell(actions)="row">
                        <input type="number" v-model="items[row.index].value" />
                      </template>
                      <template v-slot:cell(total)="row">
                        {{
                          proforma_type == 1
                            ? multiplication(row.item.exportable_kilograms, row.item.value)
                            : multiplication(row.item.net_kilograms, row.item.value)
                        }}
                      </template>
                    </b-table>
                  </div>
                </tab-content>

                <tab-content title="Creditos y débitos de la proforma" :before-change="submit">
                  <detail-modal @ok="addItem($event)" ref="modal"></detail-modal>
                  <b-row>
                    <b-col lg="6">
                      <h4>
                        Créditos
                        <a
                          href="#"
                          v-b-modal.modal-credit-debit
                          @click.prevent="$refs['modal'].detailForm.detail_type = 2"
                          ><i class="fa fa-plus-circle"></i
                        ></a>
                      </h4>
                      <b-table
                        small
                        striped
                        hover
                        :filter-function="filterTable"
                        :filter="1"
                        :fields="fields2"
                        :items="proforma_details"
                      >
                        <template v-slot:cell(action)="row">
                          <a href="#" @click.prevent="removeItem(row.index)"
                            ><i class="fa fa-remove text-danger"></i
                          ></a>
                        </template>
                      </b-table>
                    </b-col>
                    <b-col lg="6">
                      <h4>
                        Débitos
                        <a
                          href="#"
                          v-b-modal.modal-credit-debit
                          @click.prevent="$refs['modal'].detailForm.detail_type = 1"
                          ><i class="fa fa-plus-circle"></i
                        ></a>
                      </h4>
                      <b-table
                        small
                        striped
                        hover
                        :filter="2"
                        :filter-function="filterTable"
                        :fields="fields2"
                        :items="proforma_details"
                      >
                        <template v-slot:cell(action)="row">
                          <a href="#" @click.prevent="removeItem(row.index)"
                            ><i class="fa fa-remove text-danger"></i
                          ></a>
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                </tab-content>

                <tab-content title="Reporte">
                  <report :proforma="proforma"></report>
                </tab-content>
              </form-wizard>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import _ from "lodash";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css";
import { validationMixin } from "vuelidate";
import { required, decimal, maxLength } from "vuelidate/lib/validators";
import miniToastr from "mini-toastr";
import Report from "./Report";
import DetailModal from "./DetailModal";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

numeral.locale("es");
moment.locale("es");

import { mapState } from "vuex";

export default {
  name: "CreateProforma",
  components: {
    DateRangePicker,
    Report,
    DetailModal
  },
  filters: {
    fecha(value) {
      return moment(value).format("DD-MM-YYYY");
    },
    week(value) {
      return moment(value).week();
    }
  },
  created() {
    this.getCustomers();

    //https://mindicador.cl/api/{tipo_indicador}/{dd-mm-yyyy}
    this.$axios({
      method: "get",
      url: "https://mindicador.cl/api/dolar/",
      headers: ""
    })
      .then((res) => {
        this.currency = res.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  data() {
    return {
      // Copy values
      copy: null,

      // Daterange picker
      locale: {
        direction: "ltr", //direction of text
        format: "DD-MM-YYYY", //fomart of the dates displayed
        separator: " - ", //separator between the two ranges
        applyLabel: "Ok",
        cancelLabel: "Cancelar",
        weekLabel: "S",
        customRangeLabel: "Custom Range",
        daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
        monthNames: moment.monthsShort(), //array of month names - see moment documenations for details
        firstDay: 1 //ISO first day of week - see moment documenations for details
      },
      ranges: {
        // 'Hoy': [moment(), moment()],
        // 'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        "Este mes": [moment().startOf("month"), moment().endOf("month")],
        "1ra Quincena": [moment().startOf("month"), moment().startOf("month").add(14, "days")],
        "2da Quincena": [moment().startOf("month").add(15, "days"), moment().endOf("month")],
        "Este año": [moment().startOf("year"), moment().endOf("year")],
        "Semana Pasada": [moment().subtract(1, "week").startOf("week"), moment().subtract(1, "week").endOf("week")],
        "Mes pasado": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")]
      },
      showWeekNumbers: true,
      autoApply: true,
      now: moment(new Date()).format(),
      dateRange: null,
      startDate: new Date(),
      endDate: new Date(),

      loading: false,

      proforma: null,

      proforma_details: [],
      fields2: [
        { key: "description", label: "Descripción", class: "text-left" },
        { key: "quantity", label: "Cantidad", class: "text-center" },
        { key: "price", label: "Precio", class: "text-center" },
        { key: "total", label: "Total", class: "text-center" },
        { key: "action", label: " ", class: "text-right" }
      ],

      currency_selected: null,
      customers: [{ value: "", text: "Cargando..." }],
      companies: [{ text: "Seleccione exportadora...", value: "" }],
      currency: { serie: null },
      company: null,
      description: null,
      client_customer: null,
      items: [],
      fields: [
        { key: "process_birth_type", label: "Creación", sortable: false, class: "text-center" },
        { key: "week", label: "Sem", sortable: false, class: "text-center" },
        { key: "pallet", label: "Pallet", sortable: false, sortDirection: "desc" },
        { key: "waybill", label: "Guia", sortable: false, class: "text-center" },
        { key: "waybill_date", label: "Fecha", sortable: false, class: "text-center" },
        // { key: "lot", label: "Lote", sortable: false, class: "text-center" },
        { key: "condition", label: "Condicion", sortable: false, class: "text-center" },
        { key: "variety", label: "Variedad", sortable: false, class: "text-center" },
        { key: "custom_fields.calibre", label: "Calibre", sortable: false, class: "text-center" },
        { key: "container", label: "Formato", sortable: false, class: "text-center" },
        { key: "quantity", label: "Cantidad", sortable: false, class: "text-center" },
        { key: "id", label: "id", sortable: false, class: "text-center" },
        // {
        //   key: "lot",
        //   label: "is Active",
        //   formatter: (value, key, item) => {
        //     return value ? "Yes" : "No";
        //   },
        //   sortable: true,
        //   sortByFormatted: true,
        //   filterByFormatted: true
        // },
        { key: "actions", label: "USD/Kg" },
        { key: "total", label: "Total" }
      ]
    };
  },
  computed: {
    ...mapState({ proforma_type: (state) => state.user.proforma_type }),
    getFields() {
      let arr = this.fields;
      let item = { key: "net_kilograms", label: "Kg Netos", sortable: false, class: "text-center" };
      if (this.proforma_type == 1) {
        item = { key: "exportable_kilograms", label: "Kg Exp", sortable: false, class: "text-center" };
      }
      arr = this.fields.filter((x) => x.key !== item.key);
      arr.splice(11, 0, item);
      return arr;
    },
    proformaContentDetail() {
      var a = _.filter(this.items, function (obj) {
        return obj.value != null;
      });
      a = _(a)
        .map((item, key) => ({
          content: item.id,
          detail_type: 1, // detail_type = 1 is Adelanto
          value: item.value
        }))
        .values();
      // return JSON.stringify(a)
      return a;
    },
    totalInvoice() {
      let value = this.items.reduce(
        (acc, item) => acc + (item.value ? parseFloat(item.value).toFixed(2) * item.exportable_kilograms : 0),
        0
      );
      return value;
    },
    groupedData() {
      return _(this.items)
        .groupBy("container")
        .map((item, id) => ({
          description: id,
          bultos: _.sumBy(item, "quantity")
        }))
        .value();
    }
  },
  validations: {
    company: { required },
    currency_selected: { required, decimal },
    dateRange: { required },
    client_customer: { required },
    description: { required, maxLength: maxLength(150) }
  },
  methods: {
    copyValues() {
      const value = this.copy;
      this.copy = null;
      const data = this.items;
      for (let key in data) {
        this.items[key].value = value;
      }
    },
    filterTable(row, filter) {
      return row.detail_type != filter;
    },
    addItem(item) {
      this.proforma_details.push(item);
      this.$bvModal.hide(modal - credit - debit);
    },
    removeItem(index) {
      this.proforma_details.splice(index, 1);
    },
    validateStep1() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      } else {
        this.getProformaContents();
        return true;
      }
    },
    getCustomers() {
      this.$axios
        .get("/production/get_customers/")
        .then((res) => {
          const data = res.data.data;
          const customers = [];
          for (let key in data) {
            const customer = data[key];
            customers.push(customer);
          }
          this.customers = customers;
          this.customers.unshift({ text: "Seleccione...", value: "" });
        })
        .catch((error) => console.log(error));
    },
    getCompanies(a) {
      this.companies = [{ value: "", text: "Cargando..." }];
      this.$axios
        .get("/production/get_companies/" + a + "/")
        .then((res) => {
          const data = res.data.data;
          const companies = [];
          for (let key in data) {
            const company = data[key];
            companies.push(company);
          }
          this.companies = companies;
          this.companies.unshift({ text: "Seleccione...", value: "" });
        })
        .catch((error) => console.log(errors));
    },
    getProformaContents() {
      this.loading = true;
      this.$axios({
        method: "post",
        url: "/trading/index/",
        params: {
          start_date: moment(this.startDate).format("YYYY-MM-DD"),
          end_date: moment(this.endDate).format("YYYY-MM-DD"),
          company: this.company,
          proforma_type: this.proforma_type
        }
      })
        .then((res) => {
          this.items = res.data.data;
          miniToastr.success("Cajas cargadas con éxito", "");
          this.loading = false;
        })
        .catch((error) => {
          miniToastr.error(error, "");
          this.loading = false;
        });
    },
    updateValues(a) {
      this.startDate = a.startDate;
      this.endDate = a.endDate;
      this.dateRange = a.startDate + a.endDate;
    },
    async submit() {
      const self = this;
      try {
        const res = await self.$axios({
          method: "post",
          url: "/trading/proforma/",
          data: {
            issue_date: self.now,
            start_date: moment(self.startDate).format("YYYY-MM-DD"),
            end_date: moment(self.endDate).format("YYYY-MM-DD"),
            company: self.company,
            client_customer: self.client_customer,
            description: self.description,
            currency: self.currency_selected,
            proformacontentdetail: self.proformaContentDetail,
            proformadetail: self.proforma_details
          }
        });
        self.proforma = res.data;
        miniToastr.success("Proforma #" + res.data.number + " creada con éxito", "");
        return true;
      } catch (e) {
        miniToastr.error(e, "");
      }
    },
    multiplication(a, b) {
      let value = numeral(a * b);
      return value.format("0,0.00");
    }
  }
};
</script>

<style scoped></style>
